const NATIONAL_NUMBER_LENGTH = 10;

export const formatStoredPhoneNumber = (phoneNumber: string) => {
  const digits = phoneNumber.replace(/\D/g, "");
  const nationalDigits =
    digits.length === NATIONAL_NUMBER_LENGTH + 1 && digits.startsWith("1")
      ? digits.slice(1)
      : digits;

  if (nationalDigits.length !== NATIONAL_NUMBER_LENGTH) return phoneNumber;

  return `(${nationalDigits.slice(0, 3)}) ${nationalDigits.slice(3, 6)}-${nationalDigits.slice(6)}`;
};
